module.exports = __webpack_public_path__ + "img/front-background-m.34eb811.png";